/**
 * @prop --color: Color of heading
 *
 * @prop --stzh-heading-color: **Global**: Color of heading
 */

:host {
  width: 100%;

  --color: #{$headingColor};
  color: var(--color);

  ::slotted(a),
  ::slotted(* a) {
    color: $linkColor;
    transition: color $baseTransitionAnimationSpeed;
    border-radius: $buttonBorderRadius;
    text-underline-offset: $linkTextUnderlineOffset;
    text-decoration-line: $linkTextDecorationLine;
    text-decoration-thickness: $linkTextDecorationThickness;
    text-decoration-skip-ink: $linkTextDecorationSkipInk;

    &:hover {
      color: $linkHoverColor;
      text-decoration-line: $linkHoverTextDecorationLine;
    }

    &:hover {
      color: $linkHoverColor;
    }
  }
}

.stzh-heading {
  @include font('title');
  @include fontCurve('h2', 'heading'); // default
  color: var(--color);
  margin: 0;

  @for $i from 1 through 4 {
    &--level-#{$i} {
      @include fontCurve('h'+$i, 'heading');
    }
  }

  @each $fontCurveName, $config in $fontCurves {
    &--curve-#{$fontCurveName} {
      @include fontCurve($fontCurveName, 'heading');
    }
  }
}
